// const consoleLogger = require('./client-logger');

// let defaultLogger = consoleLogger;

// if (typeof window === 'undefined') {
//   defaultLogger = require('./server-logger');
// }

// module.exports = defaultLogger;

/**
 * 注意: common logger 的方法修改为 workspace 引用 @tencent/intl-log
 */

const logger = require('@tencent/intl-log/src');

module.exports = logger;
